<template>
  <div>
    <div class="page-header">
      <h2><span class="breadcrumb-level">订单管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">售后</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">评价管理</span></h2>
      <div class="header-actions">
        <el-select v-model="filterRating" placeholder="筛选评分" clearable style="width:120px" @change="fetchData">
          <el-option v-for="n in 5" :key="n" :label="n + '星'" :value="n" />
        </el-select>
        <el-select v-model="filterHidden" placeholder="显示状态" clearable style="width:120px" @change="fetchData">
          <el-option label="正常" :value="false" />
          <el-option label="已隐藏" :value="true" />
        </el-select>
        <el-input v-model="searchKeyword" placeholder="搜索评价内容/订单号" clearable prefix-icon="Search" style="width:220px" @input="fetchData" />
      </div>
    </div>

    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="订单号" width="150">
        <template #default="{row}">{{row.order?.order_no||'-'}}</template>
      </el-table-column>
      <el-table-column label="用户" width="120">
        <template #default="{row}">{{row.user?.name||row.user?.phone||'-'}}</template>
      </el-table-column>
      <el-table-column label="商品" min-width="130">
        <template #default="{row}">{{row.order_item?.product_name||'整单评价'}}</template>
      </el-table-column>
      <el-table-column label="评分" width="100">
        <template #default="{row}">
          <el-rate v-model="row.rating" disabled size="small" />
        </template>
      </el-table-column>
      <el-table-column label="评价内容" min-width="200" show-overflow-tooltip prop="content" />
      <el-table-column label="图片" width="80">
        <template #default="{row}">
          <el-image v-if="row.images?.length" :src="row.images[0]" style="width:32px;height:32px;border-radius:4px;cursor:pointer" fit="cover" :preview-src-list="row.images" preview-teleported />
          <span v-else style="color:#ccc">-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template #default="{row}">
          <el-tag :type="row.is_hidden?'danger':'success'" size="small">{{row.is_hidden?'已隐藏':'正常'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="评价时间" width="140">
        <template #default="{row}">{{formatDateTime(row.created_at)}}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template #default="{row}">
          <el-button size="small" :type="row.is_hidden?'success':'warning'" @click="handleToggle(row)">
            {{row.is_hidden?'显示':'隐藏'}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap" v-if="pagination.total>0">
      <el-pagination
        v-model:current-page="pagination.current_page"
        :page-size="pagination.per_page"
        :total="pagination.total"
        layout="total, prev, pager, next"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import * as api from '../../api/orders';

const list = ref([]);
const loading = ref(false);
const filterRating = ref('');
const filterHidden = ref('');
const searchKeyword = ref('');
const pagination = ref({ current_page: 1, per_page: 20, total: 0 });

const formatDateTime = (v) => { if (!v) return '-'; const d = new Date(v); if (isNaN(d.getTime())) return v; return d.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }); };

const fetchData = async () => {
  loading.value = true;
  try {
    const params = { page: pagination.value.current_page, per_page: pagination.value.per_page };
    if (filterRating.value) params.rating = filterRating.value;
    if (filterHidden.value !== '' && filterHidden.value !== null) params.is_hidden = filterHidden.value;
    if (searchKeyword.value) params.search = searchKeyword.value;
    const r = await api.getReviewList(params);
    const d = r.data || {};
    list.value = d.data || [];
    pagination.value = d.pagination || d || { current_page: 1, per_page: 20, total: 0 };
  } catch {} finally { loading.value = false; }
};

const onPageChange = (page) => { pagination.value.current_page = page; fetchData(); };

const handleToggle = async (row) => {
  try {
    await api.toggleReviewHide(row.id);
    ElMessage.success(row.is_hidden ? '已显示' : '已隐藏');
    await fetchData();
  } catch (e) { ElMessage.error(e.response?.data?.message || '操作失败'); }
};

onMounted(fetchData);
</script>

<style scoped>
.header-actions { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
.pagination-wrap { display: flex; justify-content: flex-end; margin-top: 16px; }
</style>